// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__6R0QG","ScrollX":"Scroll_ScrollX__3D_Ig","ScrollY":"Scroll_ScrollY__1mBY5"};